module.exports = __webpack_public_path__ + "img/guineabissau.b9334bae.svg";